import React from 'react';
import axios, { CancelToken } from 'axios';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { signUpAndSendQuote } from '../../sign/actions';

import QuoteFormSignup from '../../../component/quote/QuoteFormSignup';
import SpinnerLoading from '../../../component/common/SpinnerLoading';
import ModalCongrats from '../../../component/sign/ModalCongrats';
import { SOMETHING_WENT_WRONG_ERROR_TEXT } from '../../../util/error';
import api from '../../../service/api';
import { push } from 'connected-react-router';
import { modalClose } from '../../../actions';

const ContainerStyled = styled.div`
  margin-top: 64px;
  width: 740px;
  margin-left: auto;
  margin-right: auto;
`;

export class QuoteRequestSignUpFormContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      product: {},
      cancelSourceFetchData: CancelToken.source(),
      error: null,
    };
  }

  componentDidMount = async () => {
    try {
      const productId = this.props.match.params.productId;
      const res = await api.quoteRequestProductGet(
        productId,
        this.state.cancelSourceFetchData.token
      );

      this.setState({
        product: res.data,
        isLoading: false,
      });
    } catch (err) {
      if (!axios.isCancel(err)) {
        this.setState({ error: SOMETHING_WENT_WRONG_ERROR_TEXT, isLoading: false });
      }
    }
  };

  componentWillUnmount() {
    this.state.cancelSourceFetchData.cancel();
  }

  render() {
    return this.state.isLoading ? (
      <SpinnerLoading centered={true} />
    ) : (
      <ContainerStyled>
        {this.state.error ? (
          <div>
            <div>{this.state.error}</div>
          </div>
        ) : (
          <QuoteFormSignup
            product={this.state.product}
            company={this.state.product.clientCompany}
            userId={this.props.user._id}
            userCompanyId={this.props.activeCompanyId}
            onSubmit={this.props.signUpAndSendQuoteOnSubmit}
          />
        )}

        <div>
          {this.props.signupAndSendQuoteDone && (
            <ModalCongrats
              onClick={() => {
                let redirectPath = '/dashboard';

                this.props.signUpAndSendQuoteCongratsFinished(redirectPath);
              }}
            />
          )}
        </div>
      </ContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.account.user,
  signupAndSendQuoteDone: state.sign.signupAndSendQuoteDone,
  activeCompanyId: state.dashboard.activeCompanyId,
});

const mapDispatchToProps = (dispatch) => ({
  signUpAndSendQuoteOnSubmit: (data, setSubmitting, setErrors) =>
    dispatch(signUpAndSendQuote(data, setSubmitting, setErrors)),
  signUpAndSendQuoteCongratsFinished: (redirectPath) => {
    dispatch(modalClose());
    dispatch(push(redirectPath));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(QuoteRequestSignUpFormContainer)
);



// WEBPACK FOOTER //
// ./src/container/quote/QuoteRequestSignUpFormContainer/index.js